import React, { useState, useEffect, useRef } from "react";
import { ChevronRight, Info, X } from "react-feather";
import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import ReactTooltip from "react-tooltip";
import styles from "../PanelTopFilter/PanelTopFilter.module.scss";
import { childToolTip, getTotalCount, parentToolTip } from "@core/global/global-country-functions";
import DateRangeContainer from "../ShipmentsDateRange/DateRangePickerContainer.jsx";
import UpgradeIconSmall from "@assets/images/zap-icon.svg";
import HsCodeViewAll from "../Filters/HsCodeViewAll.jsx";
import LocaliseViewAll from "../Filters/LocalisationViewAll.jsx";
import ProximityViewAll from "../Filters/ProximityViewAll.jsx";
import RadioButtonViewAll from "../Filters/RadioButtonViewAll.jsx";
import RangeViewAll from "../Filters/RangeViewAll.jsx";
import ViewAll from "../Filters/ViewAll.jsx";
import { filterTypeDictionary as filterType, requestObjectTypeDictionary as requestObjectType } from "@core/global/global-country-dictionary";
import LoaderImg from "@assets/images/loader.gif";
import { useSelector, useDispatch } from "react-redux";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { filterObjectHandler, filterLoaderHandler, filterMustNotHandler } from "@redux/Shipment/shipmentSlice";
import * as Sentry from "@sentry/browser";
import axios from "axios";
import RangeMultiSelect from "../Filters/RangeMultiSelect.jsx";
import FilterClearIcon from "@assets/images/FilterClearIcon.jsx";
import DummyDateRange from "./DummyDateRange";

let cancelTokenSource = null;
const PanelTopFilter = (props) => {
  const dispatch = useDispatch();
  const shipmentDetails = useSelector((state) => state.shipmentDetails);
  const [hasMore, setHasMore] = useState(true);
  const [loader, setLoader] = useState(false);
  const [searchedData, setSearchedData] = useState([]);
  const [noDataFound, setNoDataFound] = useState(false);
  const [openFilterDrop, setOpenFilterDrop] = useState(false);
  const [openFilterSubDrop, setOpenFilterSubDrop] = useState(false);
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const planDetails = useSelector((state) => state?.shipmentDetails?.planDetails);
  const STARTERPLAN = creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("starter"))?.navigate === "search";
  const searchDisable = STARTERPLAN && planDetails?.search_starter_current_count >= planDetails?.search_starter_max_count;
  const getFilterDataHandler = async (filterDetails, must_not, searchInput, extraPayload) => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Operation canceled due to new request.");
    }
    cancelTokenSource = axios.CancelToken.source();

    if (!must_not) {
      dispatch(filterLoaderHandler(true));
    } else {
      setLoader(true);
    }

    try {
      let searchRequestObj = Object.keys(props.existingSearchReqObj || {}).length > 0 ? JSON.parse(JSON.stringify(props.existingSearchReqObj)) : props.buildRequestObj ? props.buildRequestObj() : {};
      if (filterDetails.key && filterDetails.altKey) {
        searchRequestObj[filterDetails.key] = [];
        searchRequestObj[filterDetails.altKey] = props?.appliedStateFilterObject[filterDetails.key] ?? [];
        searchRequestObj.opened_filter = [filterDetails.key, filterDetails.altKey];
      } else {
        searchRequestObj[filterDetails.key] = props?.appliedStateFilterObject[filterDetails.key] ?? [];
        searchRequestObj.opened_filter = [filterDetails.key];
      }
      if (filterDetails.additionalType) {
        searchRequestObj[filterDetails.additionalKey] = [];
      }
      searchRequestObj.isFilterDataIncludes = true;
      searchRequestObj.companyType = "";
      if (extraPayload) {
        searchRequestObj.hscode_expanded = extraPayload.hscode_expanded;
      }
      if (must_not) {
        searchRequestObj[`${filterDetails.key}_must_not`] = must_not;
      }
      if (searchInput) {
        searchRequestObj.filter_autosuggest = searchInput;
      }
      let filterObjectClone = JSON.parse(JSON.stringify(shipmentDetails.filterObject));

      let { data } = await axios.post(props.defaultData.apiEndPoints.getSearchResult, searchRequestObj, { cancelToken: cancelTokenSource.token });
      if (data[filterDetails.key]?.length === 0 || data[filterDetails.key] === undefined) {
        setNoDataFound(true);
      }
      setHasMore(data?.[filterDetails?.key]?.length === 1000);
      if (searchInput && filterDetails.key !== "hsCode") {
        setSearchedData([]);
        if (!must_not) setSearchedData(data[filterDetails.key]);
        dispatch(filterMustNotHandler(data[`${filterDetails.key}_must_not`]));
      } else {
        setSearchedData([]);
        if (props.lastRequestType === requestObjectType.search || props.lastRequestType === requestObjectType.reloadSearch) {
          if (filterDetails.type === filterType.boxFilter && !data[filterDetails.key].length) return;
          if (data[`${filterDetails.key}_must_not`]) {
            dispatch(filterMustNotHandler(data[`${filterDetails.key}_must_not`]));
          }
          if (filterDetails.key === "hsCode" && data[filterDetails.key] && extraPayload?.hscode_expanded?.length === 2) {
            const updatedArray = [...filterObjectClone[filterDetails.key]];
            updatedArray[extraPayload.target_index] = {
              ...updatedArray[extraPayload.target_index],
              values: data[filterDetails.key],
            };
            return dispatch(
              filterObjectHandler({
                ...filterObjectClone,
                [filterDetails.key]: updatedArray,
              })
            );
          } else if (filterDetails.key === "hsCode" && data[filterDetails.key] && extraPayload?.hscode_expanded?.length === 4) {
            const updatedArray = [...filterObjectClone[filterDetails.key]];
            const outerIndex = updatedArray.findIndex((twodigitHSCode) => extraPayload?.hscode_expanded.startsWith(twodigitHSCode.key));
            const innerIndex = updatedArray[outerIndex]?.values.findIndex((fourDigitHSCode) => fourDigitHSCode.key === extraPayload?.hscode_expanded);

            updatedArray[outerIndex].values[innerIndex] = { ...updatedArray[outerIndex].values[innerIndex], values: data[filterDetails.key] };
            return dispatch(
              filterObjectHandler({
                ...filterObjectClone,
                [filterDetails.key]: updatedArray,
              })
            );
          }
          return dispatch(filterObjectHandler({ ...filterObjectClone, [filterDetails.key]: must_not ? [...shipmentDetails.filterObject[filterDetails.key], ...data[filterDetails.key]] : data[filterDetails.key], [filterDetails.additionalKey]: data[filterDetails.additionalKey] }));
        } else {
          if (!shipmentDetails.filterObject?.[filterDetails.key]?.length || !shipmentDetails.appliedFilter[filterDetails.key]?.length || must_not || searchInput) {
            if (data[`${filterDetails.key}_must_not`]) {
              dispatch(filterMustNotHandler(data[`${filterDetails.key}_must_not`]));
            }
            dispatch(filterObjectHandler({ ...filterObjectClone, [filterDetails.key]: must_not ? [...shipmentDetails.filterObject[filterDetails.key], ...data[filterDetails.key]] : data[filterDetails.key], [filterDetails.additionalKey]: data[filterDetails.additionalKey] }));
            if (filterDetails.key === "hsCode" && data[filterDetails.key] && extraPayload?.hscode_expanded?.length === 2) {
              const updatedArray = [...filterObjectClone[filterDetails.key]];
              updatedArray[extraPayload.target_index] = {
                ...updatedArray[extraPayload.target_index],
                values: data[filterDetails.key],
              };
              dispatch(
                filterObjectHandler({
                  ...filterObjectClone,
                  [filterDetails.key]: updatedArray,
                })
              );
            } else if (filterDetails.key === "hsCode" && data[filterDetails.key] && extraPayload?.hscode_expanded?.length === 4) {
              const updatedArray = [...filterObjectClone[filterDetails.key]];
              const outerIndex = updatedArray.findIndex((twodigitHSCode) => extraPayload?.hscode_expanded.startsWith(twodigitHSCode.key));
              const innerIndex = updatedArray[outerIndex]?.values.findIndex((fourDigitHSCode) => fourDigitHSCode.key === extraPayload?.hscode_expanded);
              updatedArray[outerIndex].values[innerIndex] = { ...updatedArray[outerIndex].values[innerIndex], values: data[filterDetails.key] };
              dispatch(
                filterObjectHandler({
                  ...filterObjectClone,
                  [filterDetails.key]: updatedArray,
                })
              );
            }
          } else {
            if (filterDetails.key === "hsCode" && data[filterDetails.key] && extraPayload?.hscode_expanded?.length === 2) {
              const updatedArray = [...filterObjectClone[filterDetails.key]];
              updatedArray[extraPayload.target_index] = {
                ...updatedArray[extraPayload.target_index],
                values: data[filterDetails.key],
              };
              dispatch(
                filterObjectHandler({
                  ...filterObjectClone,
                  [filterDetails.key]: updatedArray,
                })
              );
              return;
            } else if (filterDetails.key === "hsCode" && data[filterDetails.key] && extraPayload?.hscode_expanded?.length === 4) {
              const updatedArray = [...filterObjectClone[filterDetails.key]];
              const outerIndex = updatedArray.findIndex((twodigitHSCode) => extraPayload?.hscode_expanded.startsWith(twodigitHSCode.key));
              const innerIndex = updatedArray[outerIndex]?.values.findIndex((fourDigitHSCode) => fourDigitHSCode.key === extraPayload?.hscode_expanded);
              updatedArray[outerIndex].values[innerIndex] = { ...updatedArray[outerIndex].values[innerIndex], values: data[filterDetails.key] };
              dispatch(
                filterObjectHandler({
                  ...filterObjectClone,
                  [filterDetails.key]: updatedArray,
                })
              );
              return;
            }
            if (props.excludeFilter.includes(filterDetails.key)) {
              dispatch(filterObjectHandler({ ...filterObjectClone, [filterDetails.key]: data[filterDetails.key] }));
            } else {
              if (filterDetails.type === filterType.boxFilter) {
                return dispatch(filterObjectHandler({ ...filterObjectClone, [filterDetails.key]: data[filterDetails.key] }));
              }
              let includedFiltersDataObj = {};
              data[filterDetails.key].forEach((filter) => {
                if (filter.region) {
                  let filterRegionObj = {};
                  filter.region.forEach((regionFilter) => {
                    filterRegionObj[regionFilter.key] = { ...regionFilter };
                  });
                  includedFiltersDataObj[filter.key] = { ...filter, region: { ...filterRegionObj } };
                } else if (filter.values) {
                  if (filter.values) {
                    let filterRegionObj = {};
                    filter.values.forEach((regionFilter) => {
                      filterRegionObj[regionFilter.key] = { ...regionFilter };
                    });
                    includedFiltersDataObj[filter.key] = { ...filter, values: { ...filterRegionObj } };
                  }
                } else {
                  includedFiltersDataObj[filter.key] = { ...filter };
                }
              });
              filterObjectClone[filterDetails.key] = filterObjectClone[filterDetails.key].map((filter) => {
                if (includedFiltersDataObj[filter.key]) {
                  const includedFilter = includedFiltersDataObj[filter.key];
                  if (filter.region) {
                    let filterReg = filter.region.map((regionFilter) => {
                      if (includedFilter?.region?.[regionFilter.key]) {
                        return includedFilter.region[regionFilter.key];
                      }
                      return regionFilter;
                    });
                    includedFilter.region = [...filterReg];
                  } else if (filter.values) {
                    let filterReg = filter.values.map((regionFilter) => {
                      if (includedFilter?.values?.[regionFilter.key]) {
                        return includedFilter.values[regionFilter.key];
                      }
                      return regionFilter;
                    });
                    includedFilter.values = [...filterReg];
                  }
                  return { ...includedFilter };
                }
                return filter;
              });
              if (data[`${filterDetails.key}_must_not`]) {
                dispatch(filterMustNotHandler(data[`${filterDetails.key}_must_not`]));
              }
              if (filterDetails?.type?.includes("normal-filter") || filterDetails?.type?.includes("localization-filter") || filterDetails?.type?.includes("proximity-filter")) {
                dispatch(filterObjectHandler({ ...filterObjectClone, [filterDetails.key]: must_not ? [...shipmentDetails.filterObject[filterDetails.key], ...data[filterDetails.key]] : data[filterDetails.key], [filterDetails.additionalKey]: data[filterDetails.additionalKey] }));
              } else dispatch(filterObjectHandler({ ...filterObjectClone }));
            }
          }
        }
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        Sentry.captureException(error);
      }
    } finally {
      dispatch(filterLoaderHandler(false));
      setLoader(false);
    }
  };
  const [toggleValue, setToggleValue] = useState(null);
  const divRef = useRef(null);

  useEffect(() => {
    if (!props.filterModuleSelected) setToggleValue(null);
  }, [props.filterModuleSelected]);

  //outside click for morre options - start
  const filterDropRef = useRef(null);
  const filterSubDropRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!filterDropRef.current?.contains(event.target)) setOpenFilterDrop(false);
      if (!filterSubDropRef.current?.contains(event.target)) setOpenFilterSubDrop(false);
    };

    if (openFilterDrop || openFilterSubDrop) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openFilterDrop, openFilterSubDrop]);
  //outside click for morre options - end

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  });

  const handleClickOutside = (e) => {
    if (!divRef?.current?.contains(e.target)) {
      setToggleValue(null);
    }
  };

  return (
    <>
      <div className={`${styles.filterparentcontainer} ${searchDisable ? "tw-opacity-50" : ""}`} onClick={() => props?.handleGetInTouchOpen()}>
        {props.zeroFilterData === "" || props.zeroFilterData > 0 ? <>{searchDisable ? <DummyDateRange fromDate={props.fromAccutalArrivalDate} toDate={props.toAccutalArrivalDate} /> : <DateRangeContainer latestActualArrivalDate={props.latestActualArrivalDate} userCredit={props.userCredit} fromAccutalArrivalDate={props.fromAccutalArrivalDate} toAccutalArrivalDate={props.toAccutalArrivalDate} paidPlanDateRange={props.paidPlanDateRange} defaultData={props.defaultData} monthObject={props.monthObject} onShowHandler={props.onShowHandler} onHideHandler={props.onHideHandler} monthRangePickerDismiss={(e) => props.monthRangePickerDismiss(e)} monthRangePickerChange={(e) => props.monthRangePickerChange(e)} selectDateRangePicker={(e) => props.selectDateRangePicker(e)} currentPlanAccess={props.currentPlanAccess} />}</> : <></>}
        <div className={styles.flexaligncenter}>
          <>
            {props.zeroFilterData === "" || props.zeroFilterData > 0 ? (
              <div className={styles.filtercontainer} ref={divRef}>
                {Object.keys(props.categoryName).map((item, index) => (
                  <div key={index} className={styles.positionrel}>
                    <ReactTooltip
                      className={styles.trademo_tooltip}
                      id={props.categoryName[item]}
                      place="right"
                      getContent={[
                        (dataTip) => {
                          let data = dataTip ? dataTip.split("//") : [];
                          return (
                            <span>
                              {!!dataTip && dataTip !== "" ? (
                                data.map((item) => (
                                  <div className="parent-tooltip" key={item}>
                                    {item
                                      ? item.split(";;").map((val) => (
                                          <div key={val}>
                                            {val && val.includes("|") ? (
                                              <span>{val.split("|").join("   ").trim().split("  ").join(" | ")}</span>
                                            ) : (
                                              <span>
                                                <strong>{val}</strong>
                                              </span>
                                            )}
                                          </div>
                                        ))
                                      : ""}
                                  </div>
                                ))
                              ) : (
                                <></>
                              )}
                            </span>
                          );
                        },
                        100,
                      ]}
                      effect="solid"
                      delayHide={10}
                      delayShow={10}
                      delayUpdate={10}
                    />
                    <div
                      className={styles.filteritem}
                      onMouseOver={() => props.mouseOverToolTip(item)}
                      onClick={() => {
                        if (!searchDisable) {
                          props.fillDataHandler(item);
                          setToggleValue(toggleValue === item ? null : item);
                        }
                      }}>
                      <div className={`${styles.flexaligncenter} ${getTotalCount(item, props.filterMapList, shipmentDetails.appliedFilter, props.searchedProximityFilterData, props.specialTooltipKeywords, props.appliedBooleanFilterObject, props.appliedBoxFilterObj, props.defaultBoxFilterObj) > 0 ? styles["gap-4"] : ""}`}>
                        <span className={styles.filtertitletext}>{props.categoryName[item]}</span>
                        <div className={styles.flexaligncenter}>
                          {getTotalCount(item, props.filterMapList, shipmentDetails.appliedFilter, props.searchedProximityFilterData, props.specialTooltipKeywords, props.appliedBooleanFilterObject, props.appliedBoxFilterObj, props.defaultBoxFilterObj) > 0 && (
                            <div className={styles.bluepillfilter}>
                              <span data-for={props.categoryName[item]} data-tip={parentToolTip(shipmentDetails.appliedFilter, props.mouseFilterList, props.searchedProximityFilterData, props.specialTooltipKeywords, props.appliedBooleanFilterObject, props.includeFilter, props.excludeFilter, shipmentDetails.filterObject)} className={styles.bluepillfilter}>
                                {getTotalCount(item, props.filterMapList, shipmentDetails.appliedFilter, props.searchedProximityFilterData, props.specialTooltipKeywords, props.appliedBooleanFilterObject, props.appliedBoxFilterObj, props.defaultBoxFilterObj) > 0 ? <span className={styles.badgefilterno}>{getTotalCount(item, props.filterMapList, shipmentDetails.appliedFilter, props.searchedProximityFilterData, props.specialTooltipKeywords, props.appliedBooleanFilterObject, props.appliedBoxFilterObj) > 0 ? getTotalCount(item, props.filterMapList, shipmentDetails.appliedFilter, props.searchedProximityFilterData, props.specialTooltipKeywords, props.appliedBooleanFilterObject, props.appliedBoxFilterObj) : <></>}</span> : <></>}
                                {getTotalCount(item, props.filterMapList, shipmentDetails.appliedFilter, props.searchedProximityFilterData, props.specialTooltipKeywords, props.appliedBooleanFilterObject, props.appliedBoxFilterObj) > 0 && props.showCloseHandler(item, getTotalCount(item, props.filterMapList, shipmentDetails.appliedFilter, props.searchedProximityFilterData, props.specialTooltipKeywords, props.appliedBooleanFilterObject, props.appliedBoxFilterObj)) ? (
                                  <span className={styles.flexaligncenter}>
                                    <span className={styles.badgepill}>
                                      <X
                                        size={14}
                                        color="#5A1CE2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          props.clearMainFilter(item);
                                        }}
                                      />
                                    </span>
                                  </span>
                                ) : (
                                  <></>
                                )}
                              </span>
                            </div>
                          )}
                          {toggleValue !== item ? (
                            <span className={styles.mb_1}>
                              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#5f6368">
                                <path d="M480-333 240-573l51-51 189 189 189-189 51 51-240 240Z" />
                              </svg>
                            </span>
                          ) : (
                            <span className={styles.mb_1}>
                              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#5f6368">
                                <path d="M480-525 291-336l-51-51 240-240 240 240-51 51-189-189Z" />
                              </svg>
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    {toggleValue === item && (
                      <div className={styles.filterdropdowncard}>
                        {props.selectedFilterList.map((val) => (
                          <div
                            className={styles.filtertitletext}
                            onClick={() => {
                              getFilterDataHandler(val);
                              props.viewAllFilter(props.filterTypeEnum[val.key]);
                            }}
                            key={val.key}>
                            <div className={styles.cursor_pointer}>
                              <div className={styles.filteritemtext}>
                                {val.label}
                                {val?.showNew ? <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1671105392/intel/icons/icon-new-badge_gdiz3b.svg`} /> : null}
                                {props.currentPlanAccess[val.key] === false ? <img alt="" src={UpgradeIconSmall} /> : ""}
                                {val.infoText ? <Info data-for={val.infoText} data-tip={val.infoText} size={15} /> : ""}
                              </div>
                              {val.infoText ? (
                                <ReactTooltip
                                  className={styles.trademo_tooltip}
                                  id={val.infoText}
                                  place="right"
                                  getContent={[
                                    (dataTip) => {
                                      return <span className={styles.text_capitalise}>{dataTip}</span>;
                                    },
                                    100,
                                  ]}
                                  effect="solid"
                                  delayHide={10}
                                  delayShow={10}
                                  delayUpdate={10}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                            <div className={styles.flexaligncenter}>
                              {(filterType.radioFilter !== val.type && shipmentDetails.appliedFilter[val.key] && shipmentDetails.appliedFilter[val.key].length) || (filterType.radioFilter === val.type && !shipmentDetails.appliedFilter[val.key]) || shipmentDetails?.appliedFilter[val?.additionalKey]?.length ? (
                                <span className={styles.flexaligncenter}>
                                  <ReactTooltip
                                    className={styles.trademo_tooltip}
                                    id={props.filterTypeEnum[val.key]}
                                    place="right"
                                    getContent={[
                                      (dataTip) => {
                                        return (
                                          <div>
                                            <p>{props.includeFilter.includes(val.key) || props.includeFilter.includes(val?.additionalKey) ? " Including" : props.excludeFilter.includes(val.key) ? " Excluding" : ""}</p>
                                            <span className={styles.text_notransform}>{dataTip}</span>
                                          </div>
                                        );
                                      },
                                      100,
                                    ]}
                                    effect="solid"
                                    delayHide={10}
                                    delayShow={10}
                                    delayUpdate={10}
                                  />
                                  <span className={styles.bluepillfilter} data-for={props.filterTypeEnum[val.key]} data-tip={childToolTip(shipmentDetails, val)}>
                                    {!!shipmentDetails.appliedFilter[val.key] && Array.isArray(shipmentDetails.appliedFilter[val.key]) && shipmentDetails.appliedFilter[val.key].length > 0 ? <span className={styles.badgefilterno}>{props.specialTooltipKeywords[val.key] && props.proximityApplied && props.searchedProximityFilterData.selectedZipcode.length > 0 && !!shipmentDetails.appliedFilter && !!val && !!shipmentDetails.appliedFilter[val.key] && !!shipmentDetails.appliedFilter[val.key].length ? shipmentDetails.appliedFilter[val.key].length : shipmentDetails.appliedFilter[val.key].length}</span> : filterType.radioFilter === val.type && !props.appliedBooleanFilterObject[val.key] ? <span className={styles.badgefilterno}>1</span> : shipmentDetails.appliedFilter[val?.additionalKey]?.length ? <span className={styles.badgefilterno}>{shipmentDetails.appliedFilter[val?.additionalKey]?.length}</span> : <></>}
                                    {Array.isArray(shipmentDetails.appliedFilter[val.key]) || (filterType.radioFilter === val.type && typeof props.appliedBooleanFilterObject[val.key] === "boolean" && !props.appliedBooleanFilterObject[val.key]) || (filterType.boxFilter === val.type && props.appliedBoxFilterObj && props.appliedBoxFilterObj[val.key] && props.appliedBoxFilterObj[val.key].length) ? (
                                      !((props.isRedirect === true || props.isReloadFromDashboard === true) && ((!!props.redirectingCompanyExporterId && props.redirectingCompanyExporterId.length && val.key === props.filterTypeEnum[props.specialFields.shipper]) || (!!props.redirectingCompanyImporterId && props.redirectingCompanyImporterId.length && val.key === props.filterTypeEnum[props.specialFields.consignee]) || (props.redirectingProfileType && val.key === props.redirectingProfileType) || (props.redirectingProfilePartnerType && val.key === props.redirectingProfilePartnerType))) ? (
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            props.clearIndividualFilter(val);
                                          }}
                                          className={styles.badgepill}>
                                          <span className={styles.margin_paddingZero}>
                                            <X size={14} className={styles.x} />
                                          </span>
                                        </span>
                                      ) : (
                                        ""
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                </span>
                              ) : (
                                <></>
                              )}
                              <ChevronRight size={16} color="#1a1722" />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <></>
            )}

            <div>
              {!!shipmentDetails.appliedFilter && props.checkforFilters(shipmentDetails.appliedFilter) ? (
                <>
                  <button
                    type="button"
                    className={styles.btnclearAll}
                    data-tip="Clear all filters"
                    data-for="clear-button"
                    onClick={() => {
                      props.checkPendoEventForCompanyRedirection(trackingEventDictionary.clearFilter);
                      props.resetFilter();
                    }}>
                    <div className={styles.outercircle}>
                      <FilterClearIcon />
                    </div>
                  </button>

                  <ReactTooltip place="bottom" type="dark" effect="solid" id="clear-button" />
                </>
              ) : (
                <></>
              )}
            </div>
          </>
        </div>
      </div>
      <div id="searchIndividualFilterPanel" className="view-all-filter-panel modal">
        <div className="view-all-filter-panel-content animate">
          {props.filterModuleSelected === "" ? (
            <div className="row">
              <div className="no-search-data-container text-center">
                <img src={LoaderImg} alt="description of gif" />
              </div>
            </div>
          ) : (
            <div>
              {props.filterMapList.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    {props.filterModuleSelected === item.key && item.type !== filterType.hsCodeFilter && item.type !== filterType.localizeFilter && item.type !== filterType.proximityFilter && item.type !== filterType.radioFilter && item.type !== filterType.boxFilter && item.type !== filterType.dataSourceFilter && item.type !== filterType.multiSelectRangeFilter ? (
                      <ViewAll
                        heading={item.heading}
                        noDataFound={noDataFound}
                        setNoDataFound={setNoDataFound}
                        label={item.label}
                        showInput={item.showInput}
                        placeholder={item.viewAllPlaceHolder ? item.viewAllPlaceHolder : ""}
                        filterKeyword={props.filterTypeEnum[item.key]}
                        emptyContent={item.emptyFilterText}
                        selectedFilterList={props.selectedFilterLabelObject[item.key]}
                        onApply={(e, fltrList, selectedFilterIds) => props.saveSelectedFilter(props.filterTypeEnum[item.key], null, e, item, fltrList, selectedFilterIds)}
                        onSelect={(e, includeFilterButton) => props.setMultiRangeValue(e, props.filterTypeEnum[item.additionalKey], includeFilterButton, item)}
                        closeFilter={() => props.closeViewAllFilter()}
                        appliedFilterList={shipmentDetails.appliedFilter[item.key] ? shipmentDetails.appliedFilter[item.key] : []}
                        filterList={shipmentDetails.filterObject[item.key] ? shipmentDetails.filterObject[item.key] : []}
                        selectAllFilter={props.selectAllObj[item.key]}
                        searchedFilter={props.searchedFilter[item.key]}
                        isCapitaliseInViewAll={item.isTextCapitalise}
                        isParanthesesCapital={item.isParanthesesCapital}
                        isNoTransform={item.isNoTransform}
                        includeFilter={props.includeFilter}
                        excludeFilter={props.excludeFilter}
                        getFilterDataHandler={(filterDetails, must_not, searchInput) => getFilterDataHandler(filterDetails, must_not, searchInput)}
                        filterDetails={item}
                        hasMore={hasMore}
                        showIncludeExclude={props.excludedFilter[item.key] || item.key === props.specialFields.sections ? false : true}
                        isDisabled={(props.isRedirect === true || props.isReloadFromDashboard === true) && ((!!props.redirectingCompanyExporterId && props.redirectingCompanyExporterId.length && item.key === props.filterTypeEnum[props.specialFields.shipper]) || (!!props.redirectingCompanyImporterId && props.redirectingCompanyImporterId.length && item.key === props.filterTypeEnum[props.specialFields.consignee]) || (props.redirectingProfileType && item.key === props.redirectingProfileType) || (props.redirectingProfilePartnerType && item.key === props.redirectingProfilePartnerType))}
                        loader={loader}
                        setLoader={setLoader}
                        searchedData={searchedData}
                        setSearchedData={setSearchedData}
                        additionalFilterList={shipmentDetails.filterObject[item.additionalKey] ? shipmentDetails.filterObject[item.additionalKey] : []}
                        additionalAppliedFilterList={shipmentDetails.appliedFilter[item.additionalKey] ? shipmentDetails.appliedFilter[item.additionalKey] : []}
                      />
                    ) : props.filterModuleSelected === item.key && item.type === filterType.proximityFilter ? (
                      <ProximityViewAll
                        proximityFilterDetails={props.searchedProximityFilterData}
                        filterDetails={item}
                        noDataFound={noDataFound}
                        setNoDataFound={setNoDataFound}
                        label={item.label}
                        heading={item.heading}
                        placeholder={item.viewAllPlaceHolder}
                        filterKeyword={props.filterTypeEnum[item.key]}
                        emptyContent={item.emptyFilterText}
                        setSelectAllChecked={(val) => props.setSelectAllChecked(val)}
                        appliedFilterList={shipmentDetails.appliedFilter[item.key] ? shipmentDetails.appliedFilter[item.key] : []}
                        item={item.key}
                        selectAllChecked={props.selectAllChecked}
                        selectedFilterList={props.selectedFilterLabelObject[item.key]}
                        appliedStateFilterObject={shipmentDetails.appliedFilter}
                        countryCode={props.defaultData.countryCode}
                        tradeDirection={props.defaultData.countryTypeCode}
                        closeFilter={() => props.closeViewAllFilter(props.filterTypeEnum[item.key])}
                        filterList={shipmentDetails.filterObject[item.key] ? shipmentDetails.filterObject[item.key] : []}
                        proximityClicked={props.proximityClicked}
                        searchReqObj={props.existingSearchReqObj}
                        searchedProximityData={props.searchedProximityFilterData}
                        onApply={(isProximity, tempData, selectedList, payloadRadius, zipcodeResult, searchedZipcode) => {
                          if (isProximity) {
                            let temp = {};
                            temp["appliedRadius"] = payloadRadius;
                            temp["searchedZipcode"] = searchedZipcode;
                            temp["selectedZipcode"] = [...selectedList];
                            temp["zipcodeList"] = [...zipcodeResult];
                            props.setSearchedProximityFilterData(temp);
                          }
                          props.saveSelectedFilter(props.filterTypeEnum[item.key], isProximity, null, item, tempData, selectedList);
                        }}
                        hasMore={hasMore}
                        searchedData={searchedData}
                        setSearchedData={setSearchedData}
                        getFilterDataHandler={(filterDetails, must_not, searchInput) => getFilterDataHandler(filterDetails, must_not, searchInput)}
                      />
                    ) : props.filterModuleSelected === item.key && item.type === filterType.localizeFilter ? (
                      <LocaliseViewAll
                        noDataFound={noDataFound}
                        setNoDataFound={setNoDataFound}
                        label={item.label}
                        heading={item.heading}
                        placeholder={item.viewAllPlaceHolder ? item.viewAllPlaceHolder : ""}
                        filterKeyword={props.filterTypeEnum[item.key]}
                        emptyContent={props.emptyFilterTextEnum[item.key]}
                        selectedFilterList={props.selectedFilterLabelObject[item.key]}
                        onApply={(e, fltrList, selectedFilterIds) => props.saveSelectedFilter(props.filterTypeEnum[item.key], null, e, item, fltrList, selectedFilterIds)}
                        appliedFilterList={shipmentDetails.appliedFilter[item.key] ? shipmentDetails.appliedFilter[item.key] : []}
                        closeFilter={() => props.closeViewAllFilter(props.filterTypeEnum[item.key])}
                        filterList={shipmentDetails.filterObject[item.key] ? shipmentDetails.filterObject[item.key] : []}
                        selectAllFilter={props.selectAllObj[item.key]}
                        searchedFilter={props.searchedFilter[item.key]}
                        includeFilter={props.includeFilter}
                        excludeFilter={props.excludeFilter}
                        getFilterDataHandler={(filterDetails, must_not, searchInput) => getFilterDataHandler(filterDetails, must_not, searchInput)}
                        filterDetails={item}
                        searchedData={searchedData}
                        setSearchedData={setSearchedData}
                        isDisabled={(props.isRedirect === true || props.isReloadFromDashboard === true) && ((!!props.redirectingCompanyExporterId && props.redirectingCompanyExporterId.length && item.key === props.filterTypeEnum[props.specialFields.shipper]) || (!!props.redirectingCompanyImporterId && props.redirectingCompanyImporterId.length && item.key === props.filterTypeEnum[props.specialFields.consignee]) || (props.redirectingProfileType && item.key === props.redirectingProfileType) || (props.redirectingProfilePartnerType && item.key === props.redirectingProfilePartnerType))}
                      />
                    ) : props.filterModuleSelected === item.key && item.key === props.filterTypeEnum[props.specialFields.hscode] ? (
                      <HsCodeViewAll
                        label={item.label}
                        filterDetails={item}
                        placeholder={item.viewAllPlaceHolder ? item.viewAllPlaceHolder : ""}
                        filterKeyword={props.filterTypeEnum[item.key]}
                        emptyContent={props.emptyFilterTextEnum[item.key]}
                        selectedFilterList={props.selectedFilterLabelObject[item.key]}
                        onApply={(includeFilterButton, tempData, selectedList) => {
                          let temp = JSON.parse(JSON.stringify(shipmentDetails.appliedFilter));
                          temp[item.key] = JSON.parse(JSON.stringify(selectedList));
                          props.setAppliedStateFilterObject(JSON.parse(JSON.stringify(temp)));
                          props.saveSelectedFilter(props.filterTypeEnum[item.key], null, includeFilterButton, item, tempData, selectedList);
                        }}
                        getFilterDataHandler={(filterDetails, must_not, searchInput, extraPayload) => getFilterDataHandler(filterDetails, must_not, searchInput, extraPayload)}
                        appliedFilterList={shipmentDetails.appliedFilter[item.key] ? shipmentDetails.appliedFilter[item.key] : []}
                        closeFilter={() => props.closeViewAllFilter(props.filterTypeEnum[item.key])}
                        filterList={shipmentDetails.filterObject[item.key] ? shipmentDetails.filterObject[item.key] : []}
                        onSearch={(e) => props.searchHscodeInFilter(e)}
                        mapSelectAllFilter={(e) => props.mapSelectAllFilter(item.key, e)}
                        selectAllFilter={props.selectAllObj[item.key]}
                        searchedFilter={props.searchedFilter[item.key]}
                        includeFilter={props.includeFilter}
                        excludeFilter={props.excludeFilter}
                        searchedData={searchedData}
                        setSearchedData={setSearchedData}
                      />
                    ) : props.filterModuleSelected === item.key && item.type === filterType.boxFilter ? (
                      <RangeViewAll heading={item.heading} closeFilter={() => props.closeViewAllFilter(props.filterTypeEnum[item.key])} filterName={item.label ? item.label : ""} eventKey={item.eventKey ? item.eventKey : 1} isFilterApplied={props.isFilterApplied} appliedFilterList={shipmentDetails.appliedFilter[item.key] ? shipmentDetails.appliedFilter[item.key] : []} clearIndividualFilter={(e) => props.clearIndividualFilter(e)} mainFilterList={shipmentDetails.filterObject[item.key] ? shipmentDetails.filterObject[item.key] : []} filterKeyword={props.filterTypeEnum[item.key]} onSelect={(e) => props.setRangeValue(e, props.filterTypeEnum[item.key])} emptyContent={props.emptyFilterTextEnum[[item.key]]} placeholder={item.viewAllPlaceHolder ? item.viewAllPlaceHolder : ""} item={item} />
                    ) : props.filterModuleSelected === item.key && item.type === filterType.radioFilter ? (
                      <RadioButtonViewAll label={item.label} optionValue={item} filterName={item.label ? item.label : ""} eventKey={item.eventKey ? item.eventKey : 1} optionOne={item.optionOne} optionTwo={item.optionTwo} defaultCheckedFlag={shipmentDetails.appliedFilter[item.key]} onChange={(event, type, item) => props.mapBooleanFilter(event, type, item)} infoText={item.infoText ? item.infoText : ""} filterKeyword={props.booleanFilterObject[item.key]} closeFilter={() => props.closeViewAllFilter(props.filterTypeEnum[item.key])} heading={item.heading} defaultActiveSate={props.defaultData?.defaultBooleanFilterObj?.[props?.booleanFilterObject?.[item.key]]} />
                    ) : props.filterModuleSelected === item.key && item.type === filterType.multiSelectRangeFilter ? (
                      <RangeMultiSelect
                        heading={item.heading}
                        closeFilter={() => props.closeViewAllFilter(props.filterTypeEnum[item.key])}
                        filterName={item.label ? item.label : ""}
                        eventKey={item.eventKey ? item.eventKey : 1}
                        isFilterApplied={props.checkforFilters(props.appliedFilterObject)}
                        appliedFilterList={shipmentDetails.appliedFilter[item.key] ? shipmentDetails.appliedFilter[item.key] : []}
                        clearIndividualFilter={(e) => props.clearIndividualFilter(e)}
                        filterList={shipmentDetails.filterObject[item.key] ? shipmentDetails.filterObject[item.key] : []}
                        mainFilterList={shipmentDetails.filterObject[item.key] ? shipmentDetails.filterObject[item.key] : []}
                        filterKeyword={props.filterTypeEnum[item.key]}
                        onSelect={(e, includeFilterButton) => props.setMultiRangeValue(e, props.filterTypeEnum[item.key], includeFilterButton, item)}
                        emptyContent={item.emptyFilterText}
                        placeholder={item.viewAllPlaceHolder ? item.viewAllPlaceHolder : ""}
                        item={item}
                        includeFilter={props.includeFilter}
                        excludeFilter={props.excludeFilter}
                        showIncludeExclude={false}
                      />
                    ) : (
                      <></>
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PanelTopFilter;
